<template>
  <div class="container w-100 mxw-md  ">
    <!-- <div class="hero">
      <h1 class="heading"> Booking Successful </h1>
    </div> -->
    <div class="content w-100 mxw-md " ref="content">
      <el-breadcrumb separator="/" class="m-20">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>Payment</el-breadcrumb-item>
      </el-breadcrumb>

        <!-- <el-result  title="Registration Successful">
        <template slot="extra">
          <span class="mt-10 c-gray">You should receive an email confirmation alongside the final payment details</span>
        </template>
        </el-result> -->
        <!-- go home button -->
        <!-- <assemble-button @click="go('/search')" class="mb-20 text-center d-flex justify-content-center">Make another registration</assemble-button> -->
        <div class="progress-indicator m-20">
        <div v-if="hasRegistrations" class="progress-step" :class="{ 'completed': getRegoStatus === 'success' }">
          <div class="step-icon">
            <i class="el-icon-check" v-if="getRegoStatus === 'success'"></i>
            <i class="el-icon-loading" v-else-if="getRegoStatus === 'process'"></i>
            <i class="el-icon-close" v-else></i>
          </div>
          <div class="step-label">{{ getRegoTitle }}</div>
        </div>
        <div v-if="hasRegistrations && hasStoreItems" class="progress-line"></div>
        <div v-if="hasStoreItems" class="progress-step" :class="{ 'completed': getSIStatus === 'success' }">
          <div class="step-icon">
            <i class="el-icon-check" v-if="getSIStatus === 'success'"></i>
            <i class="el-icon-loading" v-else-if="getSIStatus === 'process'"></i>
            <i class="el-icon-close" v-else></i>
          </div>
          <div class="step-label">{{ getStoreItemTitle }}</div>
        </div>
        <div v-if="hasRegistrations || hasStoreItems" class="progress-line"></div>
        <div class="progress-step" :class="{ 'completed': getOverallStatus === 'success' }">
          <div class="step-icon">
            <i class="el-icon-check" v-if="getOverallStatus === 'success'"></i>
            <i class="el-icon-loading" v-else-if="getOverallStatus === 'process'"></i>
            <i class="el-icon-close" v-else></i>
          </div>
          <div class="step-label">{{ getOverallTitle }}</div>
        </div>
      </div>
      <div >
        <success
        :isRegoBlurred="isRegoBlurred"
        :isSIBlurred="isSIBlurred"
        :confirmation="registrationsConfirmation"
        :bulkMembers="bulkMembers"
        :saleableItemConfirmation="saleableItemConfirmation"
        :regoErrorMessages="regoErrorMessages"
        :productError="productError"
        :memberIdError="memberIdError"
        :siErrorMessages="siErrorMessages"
        :memberList="memberList"
        @selectedMember="updateSelectedMember"
        :payTodayTotal="payTodayTotal"
        :totalPaid="totalPaid"
        />
      </div>

      <div class="d-flex justify-content-center pt-20">
        <!-- <el-button @click="go('/')" class="mb-20 text-center d-flex justify-content-center">Go Home</el-button> -->
        <!-- if having pending reigstration, add button to come back to that event -->
        <el-button v-if="backToRegoHistory.backToRegoHistory" type="secondary" class="mb-20 text-center d-flex justify-content-center" @click="goToRegoHistory">
          Back to Rego History
        </el-button>
        <el-button v-if="getOverallStatus === 'error'" type="secondary" class="mb-20 text-center d-flex justify-content-center" @click="goToPayment">
          Return to Checkout
        </el-button>
        <el-button type="primary" class="mb-20 text-center d-flex justify-content-center"  @click="goToFinder">
          Return to Search
        </el-button>
        <!-- if the user is registering for a team, show the invite modal -->
        <!-- <el-button type="primary" class="mb-20 text-center d-flex justify-content-center" v-if="isTeamRego" @click="showInviteModal = true">
          Register To This Team
        </el-button> -->
      </div>
    </div>
    <el-dialog
    v-if="showInviteModal"
    :title="dialogState === 'initial' ? 'Join Team' : 'Team Products'"
    :visible.sync="showInviteModal"
    width="30%"
  >
    <!-- Initial dialog content -->
    <template v-if="dialogState === 'initial'">
      <p>{{ getInvitation() }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showInviteModal = false">No</el-button>
        <el-button type="primary" @click="showProducts">Yes</el-button>
      </span>
    </template>

    <!-- Products dialog content -->
    <template v-if="dialogState === 'showProducts'">
  <div class="w-100 products-dialog d-flex flex-column gap-10">
    <!-- a select to select member first -->
    <!-- header -->
    <div class="">
      <h2 class="break-word">Select member</h2>
      <el-select v-model="memberId" placeholder="Select a member" class="w-100" @change="updateSelectedMember">
        <el-option

        v-for="member in memberList"
        :key="member._id"
        :label="`${member.profile.firstName} ${member.profile.lastName}`"
        :value="member._id"
      />
    </el-select>
    </div>

    <h2 class="break-word">Select the product you would like to register for:</h2>
      <div class="product-cards " v-for="p in teamProducts" :key="p._id">
        <div class="product-container"
          @click="handleCardClicked(p) ">
          <el-card>
            <div class="product-container-main-mobile pb-05">
              <div class="d-flex justify-content-between ">

                <div class="product-description">
                  <!-- <i class="el-icon-s-data"></i> -->
                  <div class="d-flex gap-1 tag mr-1 member-type">
                    <span>
                      <el-tag class="" v-if="p.memberType">
                        {{ p.memberType? capitalize(p.memberType) : ''   }}
                      </el-tag>
                    </span>
                  </div>
                  <div class="d-flex gap-1 tag justify-content-evenly mr-1 gender">
                    <span v-if="p.gender && p.gender !== 'undefined'">
                      <el-tag class="">
                        {{ p.gender? p.gender === 'All' ? 'All Genders': capitalize(p.gender) : '' }}
                      </el-tag>
                    </span>
                  </div>
                  <div class="d-flex gap-1  tag mr-1 age">
                    <span>
                      <el-tag class="">
                        Age {{ p.ageFrom }} {{p.ageTo !== 99 ?  `- ${p.ageTo}` : '+'}}
                      </el-tag>
                    </span>
                  </div>
                </div>
                <div class="mr-10 mt-10">
                  <span class="f-bold fs-10">
                    {{ priceFormatted(p.price) }}
                  </span>
                </div>
              </div>
              <div class="product-description">
                <span>
                  {{ p.name }}
                </span>
              </div>
            </div>
            <div v-show="true || p.showMoreDetails" :key="key" class="">
              <div class="" v-if="p.tags && p.tags.length > 0">
                <span v-for="tag in p.tags" :key="tag._id">
                  <span class="ml-05 product-tag" @click="searchByTag(tag)">
                    #{{ tag.name }}
                  </span>
                </span>
              </div>
              <div class="d-flex gap-1 justify-content-between align-items-end ">
              </div>

            </div>
            <div class="rego-flags px-10 d-flex justify-content-end f-bold">
              <el-button
                size="mini"
                v-if="['indv-to-team', 'entity'].includes(p.type)"
                :type="getButtonType(p)"
                :disabled="getButtonLabel(p) === 'Already Registered' || getButtonLabel(p) === 'Ineligible' || getButtonLabel(p) === 'Closed'"
              >
                {{ getButtonLabel(p) }}
              </el-button>
              <span class="icons ml-05" v-if="['Already Registered', 'Closed', 'Required', 'Ineligible'].includes(getButtonLabel(p))">
                <fa-icon v-if="getButtonLabel(p) == 'Required'" style="color:#E6A23C"
                  :icon="['fal', 'circle-exclamation']" />
                <fa-icon v-else-if="getButtonLabel(p) == 'Closed'" style="color:#E6A23C"
                  :icon="['fal', 'circle-exclamation']" />
                  <fa-icon v-else-if="getButtonLabel(p) == 'Ineligible'" style="color:#E6A23C"
                  :icon="['fal', 'circle-exclamation']" />
                <fa-icon v-else-if="getButtonLabel(p) == 'Already Registered'" style="color:#67C23A"
                  :icon="['fal', 'circle-check']" />
              </span>
            </div>
          </el-card>
        </div>
      </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">Close</el-button>
  </span>
</template>
  </el-dialog>
  </div>
  <!-- el dialog to ask if the user want to register for this team -->
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { calculateMemberAge } from '@/utils/helpers';
import success from './components/success.vue';

export default {
  name: 'Success',
  components: { success },
  props: {
    payment: {
      type: Object,
      default: () => {},
    },
    token1: {
      type: String,
      default: '',
    },
    token2: {
      type: String,
      default: '',
    },
    cartTotal: {
      type: Number,
      default: 0,
    },
    payTodayTotal: {
      type: Number,
      default: 0,
    },
    indvPayTodayTotal: {
      type: Number,
      default: 0,
    },
    indvCartTotal: {
      type: Number,
      default: 0,
    },
    payAfter: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    totalWithSaleableItems: {
      type: Number,
      default: 0,
    },
    getCurrentIndvCartTotal: {
      type: Function,
      default: () => {},
    },
    totalSaleableItemsWithFee: {
      type: Number,
      default: 0,
    },
  },
  inject: ['getIndvCartTotal'],
  data() {
    return {
      active: 0,
      capitalize: _.capitalize,
      localRegistration: {},
      dialogState: 'initial',
      get: _.get,
      saleableItemConfirmation: [],
      registrationsConfirmation: [],
      showConfimation: false,
      isRegoBlurred: true,
      isRegoSuccess: false,
      isSISuccess: false,
      isSIBlurred: true,
      regoErrorMessages: '',
      siErrorMessages: '',
      windowWidth: window.innerWidth,
      isTeamRego: false,
      showInviteModal: false,
      memberId: '',
      selectedMember: this.$store.getters['user/activeMember'],
      teamProducts: [],
      selectedTeam: undefined,
      memberList: [],
      memberMembership: [],
      bulkMembers: [],
      productError: undefined,
      memberIdError: undefined,
      totalPaid: 0,
    };
  },
  beforeRouteLeave(to, from, next) {
    console.log('beforeRouteLeave triggered', { to, from });
    this.$store.commit('cart/clearConfirmation');
    next();
  },

  created() {
    // Add navigation guard for top nav clicks
    const removeNavGuard = this.$router.beforeEach((to, from, next) => {
      if (from.name === 'payment' || from.name === 'custom-payment') {
        this.$store.commit('cart/clearConfirmation');
      }
      next();
    });

    // Clean up navigation guard when component is destroyed
    this.$once('hook:beforeDestroy', () => {
      removeNavGuard();
    });
  },
  computed: {

    computed: {
      currentIndvCartTotal() {
        return this.getCurrentIndvCartTotal();
      }
    },
    // memberMembership() {
    //   return this.$store.getters['user/getActiveMemberRegos'];
    // },
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    backToRegoHistory() {
      return this.$store.getters['cart/backToRegoHistory'];
    },
    hasStoreItems() {
      return this.saleableItemConfirmation && this.saleableItemConfirmation.length > 0;
    },
    hasRegistrations() {
      return this.registrationsConfirmation && this.registrationsConfirmation.length > 0;
    },
    isTablet() {
      return this.windowWidth <= 768;
    },
    ...mapGetters('cart', ['currentConfirmation', 'pendingRegistration', 'selectedBulkMembers']),
    getRegoStatus() {
      if (this.isRegoBlurred) {
        return 'process';
      }
      if (this.isRegoSuccess) {
        return 'success';
      }
      return 'error';
    },
    getSIStatus() {
      if (this.isSIBlurred) {
        return 'process';
      }
      if (this.isSISuccess) {
        return 'success';
      }
      return 'error';
    },
    getOverallStatus() {
      if ((this.isRegoBlurred && this.registrationsConfirmation.length) || (this.isSIBlurred && this.saleableItemConfirmation.length)) {
        return 'process';
      }
      if ((this.isRegoSuccess || !this.registrationsConfirmation.length) && (this.isSISuccess || !this.saleableItemConfirmation.length)) {
        return 'success';
      }
      return 'error';
    },
    getOverallTitle() {
      if ((this.isRegoBlurred && this.registrationsConfirmation.length) || (this.isSIBlurred && this.saleableItemConfirmation.length)) {
        return 'Processing';
      }
      if ((this.isRegoSuccess || !this.registrationsConfirmation.length) && (this.isSISuccess || !this.saleableItemConfirmation.length)) {
        return 'Success';
      }
      return 'Error';
    },
    getStoreItemTitle() {
      if (this.isSIBlurred) {
        return 'Processing Store Items';
      }
      if (this.isSISuccess) {
        return 'Purchased Store Items';
      }
      return 'Store Items';
    },
    getRegoTitle() {
      if (this.isRegoBlurred) {
        return 'Processing Registrations';
      }
      if (this.isRegoSuccess) {
        return 'Registered';
      }
      return 'Registrations';
    },
    currentDiscounts() {
      return this.$store.getters['cart/regoDiscounts'];
    },
  },
  async mounted() {
    if (this.totalWithSaleableItems) {
      this.totalPaid = _.cloneDeep(this.totalWithSaleableItems);
    }
    // get the params from the url
    const regos = this.$store.getters['cart/currentConfirmation'];
    const teamConfirmation = _.find(regos, (r) => r.productType === 'team');
    console.log('mounted at success');
    console.log('this.currentConfirmation', this.currentConfirmation);
    setTimeout(() => {
      if (!this.currentConfirmation) {
        console.log('no confirmation found');
        // this.$router.push('/');
      }
      this.scrollToContent();
    }, 200);
    window.addEventListener('resize', this.handleResize);
    if (this.payment && this.payment.registrations && this.payment.registrations.length >= 1) {
      console.log('this.payment.registrations', this.payment.registrations);
      // const allRegos = _.cloneDeep(this.payment.registrations);
      this.registrationsConfirmation = _.cloneDeep(this.payment.registrations.filter((r) => r.productType === 'indv' || r.productType === 'indv-to-team' || r.productType === 'family'));
    }
    console.log('this.registrationsConfirmation', this.registrationsConfirmation);
    if (teamConfirmation && !this.registrationsConfirmation.length) {
      this.registrationsConfirmation = [teamConfirmation];
      this.isRegoBlurred = false;
      this.isRegoSuccess = true;
      if (teamConfirmation.productType === 'team') {
        this.isTeamRego = true;
        // this.showInviteModal = true;
      }
    }
    if (this.payment && this.payment.directSaleableItems && this.payment.directSaleableItems.length >= 1) {
      this.saleableItemConfirmation = _.cloneDeep(this.payment.directSaleableItems);
    }
    if (this.registrationsConfirmation.length >= 1 && !this.isTeamRego) {
      this.register(this.token1);
    } else if (this.registrationsConfirmation.length === 0) {
      // No registrations to process, mark as success immediately
      this.isRegoBlurred = false;
      this.isRegoSuccess = true;
    }
    if (this.saleableItemConfirmation.length >= 1) {
      this.purchase(this.token2);
    } else if (this.saleableItemConfirmation.length === 0) {
      // No store items to process, mark as success immediately
      this.isSIBlurred = false;
      this.isSISuccess = true;
    }
    await this.getMemberList();
    if (this.currentDiscounts && this.currentDiscounts.length) this.regoDiscounts = _.cloneDeep(this.currentDiscounts);
  },
  methods: {
    goToRegoHistory() {
      const pathName = this.hasCustomEntity ? 'custom-profile' : 'profile';
      console.log('this.backToRegoHistory', this.backToRegoHistory);
      this.$router.push({ name: pathName, params: { id: this.backToRegoHistory.memberId, tabName: 'rego-history' } });
      this.$store.commit('cart/backToRegoHistory', {
        memberId: undefined,
        backToRegoHistory: false,
      });
    },
    getButtonType(product) {
      const label = this.getButtonLabel(product);
      switch (label) {
        case 'Already Registered':
        case 'Ineligible':
        case 'Closed':
          return 'info';
        case 'Required':
          return 'warning';
        case 'Pay Now':
        case 'Join':
        case 'Register':
          return 'primary';
        default:
          return 'default';
      }
    },
    getInvitation() {
      const registration = this.registrationsConfirmation[0];
      console.log('registration', registration);
      console.log('payment', this.payment);
      const { team } = registration;
      return `Would you like to register a member to ${team.name} for ${registration.name}`;
    },
    async updateSelectedMember(obj) {
      console.log('updateSelectedMember', obj);
      const { member, product, rego } = obj;
      console.log('member', member);
      console.log('product', product);
      this.memberId = member._id;
      this.memberMembership = [];
      this.selectedMember = this.memberList.find((m) => m._id === member._id);
      this.$store.commit('user/setActiveMember', this.selectedMember);
      const response = await this.$http.get(`/assemble/api/v1/portal/registrations/members/${member._id}`);
      this.memberMembership = response.data.data;
      this.$store.commit('user/setMemberRegos', this.memberMembership);
      const criteria = rego.eventId;
      this.selectedTeam = rego.team._id;
      const filters = {
        ageFrom: 1,
        ageTo: 100,
        eventDateRange: [],
        memberId: this.memberId,
        regoOpen: 'open',
      };
      this.selectedMember = this.memberList.find((m) => m._id === this.memberId);
      const resSearch = await this.$http.post('/assemble/api/v1/portal/registrations/new-search/20/1', {
        criteria: _.trim(criteria),
        filters,
      });
      [this.localRegistration] = resSearch.data.data.result;
      this.selectedProduct = this.localRegistration.product.find((p) => p.type === 'indv-to-team' && p._id === product.productDetails
        ._id);
      if (!this.selectedTeam) {
        const findTeam = this.localRegistration.teams.find((team) => team.name === rego.team.name);
        this.selectedTeam = findTeam._id;
      }
      if (this.selectedProduct) {
        this.handleCardClicked(this.selectedProduct);
      }
      // this.$store.commit('user/setMemberRegos', this.memberMembership);
      this.$forceUpdate();
    },
    checkPayAfter(productId) {
      const found = this.memberMembership
        .filter((m) => _.get(m, 'regoEntity.products._id') === productId
          && m.expired !== true);
      if (found.length) {
        // console.log('found', found);
        // return true and the found membership
        if (found[0].payAfter && found[0].payAfterMeta.fullyPaid === false) {
          return true;
        }
      }
      return false;
    },
    async getMemberList() {
      const response = await this.$http.get('/assemble/api/v1/account/portal/members');
      this.memberList = response.data.data;
      if (!this.memberId) {
        const activeMember = this.$store.getters['user/activeMember'];
        if (activeMember && activeMember._id) {
          this.memberId = activeMember._id;
        }
        // this.memberId = activeMember._id;
      }
    },
    checkFullSlot(product) {
      // get items in the cart
      const pendingRegos = this.$store.getters['cart/registrations'];
      const numberOfSameProduct = pendingRegos.filter((r) => r.product._id === product._id).length;
      const foundProduct = this.localRegistration.product.find((p) => p._id === product._id);
      const isNoMax = _.get(this, 'localRegistration.noMax');
      if (!foundProduct) return false;
      if (foundProduct.type === 'team' && !isNoMax) {
        const numOfTeams = _.get(this, 'localRegistration.teams', []).length + numberOfSameProduct;
        const maxNoTeams = _.get(this, 'localRegistration.maxNoTeams');
        if (numOfTeams !== 0 && maxNoTeams !== 0 && numOfTeams >= maxNoTeams) {
          return true;
        }
      }
      if (foundProduct.type === 'indv-to-team' && !isNoMax) {
        const regos = _.get(this, 'localRegistration.registrations', []);
        const maxNoIndvTeam = _.get(this, 'localRegistration.maxNoIndvTeam');
        const teamCounts = _.countBy(regos, (r) => (r.productType === 'indv-to-team' ? r.teamId : null));

        // Find if any team has fewer registrations than maxNoIndvTeam
        const teamsBelowMaxLimit = _.pickBy(teamCounts, (count) => count < maxNoIndvTeam);

        // If there are no teams below the max limit, then the product is full
        if (_.isEmpty(teamsBelowMaxLimit) && teamCounts > 0) {
          return true;
        }
      }
      if (foundProduct.type === 'indv' && !isNoMax) {
        const regos = _.get(this, 'localRegistration.registrations', []);
        const maxProductRego = _.get(foundProduct, 'maxRego', 0);
        const noOfIndv = _.filter(regos, (r) => r.productType === 'indv').length + numberOfSameProduct;
        const maxNoIndv = _.get(this, 'localRegistration.maxNoIndividuals');
        // console.log('maxProdcut Rego', maxProductRego);
        // console.log('noOfIndv', noOfIndv);
        if (noOfIndv !== 0 && maxNoIndv !== 0 && noOfIndv >= maxNoIndv) {
          return true;
        }
        if (maxProductRego !== 0 && noOfIndv >= maxProductRego) {
          // console.log('full slot');
          return true;
        }
      }
      return false;
    },
    priceFormatted(price) {
      // price currently in cents
      return `$${(price / 100).toFixed(2)}`;
    },
    tagsFormatted(tags) {
      // tags is an array containing objects
      return tags.map((tag) => tag.name).join(', ');
    },
    typeFormatter(type) {
      if (type === 'indv') return 'Become a member';
      if (type === 'indv-to-team') return 'Join a team';
      if (type === 'team') return 'Register a team';
      return '';
    },
    getButtonLabel(product) {
      const isMembershipRequired = this.isMembershipRequired(product);
      const isRegistered = this.checkRegistered(product._id);
      const isPayAfter = this.checkPayAfter(product._id);
      const isEligible = this.isEligible(product);
      const fullTeamSlot = this.checkFullSlot(product);
      // console.log('canJoinWaitingList', product.isWaitlistOpen, !isRegistered, !isNotEligible, product.isRegoOpen);
      // const canJoinWaitingList = this.checkIsWaitlistOpen(product);

      if (isRegistered && !isPayAfter) {
        return 'Already Registered';
      }
      if (!isEligible) {
        return 'Ineligible';
      }
      if (fullTeamSlot) {
        return 'Full';
      }
      if (!product.isActive || !product.isRegoOpen) {
        return 'Closed';
      }
      if (isMembershipRequired && !isRegistered) {
        return 'Required';
      }
      if (isRegistered && isPayAfter) {
        return 'Pay Now';
      }
      if (product.type === 'indv-to-team') {
        return 'Join';
      }
      return 'Register';
    },
    checkProductVisibility(product) {
      if (this.privateProps.entityId && this.privateProps.productId) return true;
      if (_.get(product, 'isPrivate')) {
        if (product.isVisible !== undefined) {
          if (product.isVisible) return true;
          return false;
        }
      }
      return true;
    },
    checkRegistered(productId) {
      // console.log('checkRegistered', productId);
      // console.log('this.memberMembership', this.memberMembership);
      const product = this.localRegistration.product.find((p) => p._id === productId);
      const multipleRegoAllowed = this.$store.getters['national/getMultipleRegoAllowed'];
      const found = this.memberMembership
        .filter((m) => _.get(m, 'regoEntity.products._id') === productId
          && m.expired !== true);
      if (found.length) {
        if (multipleRegoAllowed && product.type === 'indv-to-team') {
          return false;
        }
        // return true and the found membership
        return true;
      }

      return false;
    },
    checkIndvTeamRegistered(product, teamId) {
      console.log('checkIndvTeamRegistered', product, teamId);
      const foundIndvTeamRegistration = this.memberMembership
        .find((m) => _.get(m, 'regoEntity.products._id') === product._id
          && m.expired !== true
          && m.team._id === teamId);
      if (foundIndvTeamRegistration) {
        return true;
      }
      return false;
    },
    handleCardClicked(product) {
      console.log('handleCardClicked', product);
      const isMembershipRequired = this.isMembershipRequired(product);
      const isRegistered = this.checkRegistered(product._id);
      const isPayAfter = this.checkPayAfter(product._id);
      const isEligible = this.isEligible(product);
      const fullSlot = this.checkFullSlot(product);

      if (isRegistered && !isPayAfter) {
        this.$notify({
          title: 'Already Registered',
          message: 'You are already registered for this product.',
          type: 'success',
          duration: 5000,
        });
        return;
      }
      // console.log('canJoinWaitingList', product.isWaitlistOpen, !isRegistered, !isNotEligible, product.isRegoOpen);
      if (!isEligible) {
        this.$notify({
          title: 'Ineligible',
          message: 'You are not eligible to register for this product.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      if (!product.isActive || !product.isRegoOpen) {
        this.$notify({
          title: 'Registration Closed',
          message: 'Registration for this product is closed. Please contact your administrator.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      if (isMembershipRequired && !isRegistered) {
        this.$confirm('Membership is required to join this event/membership. Do you want to register the required membership? ', 'Membership Required', {
          confirmButtonText: 'Get Membership',
          cancelButtonText: 'No',
          type: 'warning',
        }).then(async () => {
          console.log('membershuip required', product.membershipProductsRequired);
          const regoObj = this.generateRegoObject([product], this.selectedTeam);
          this.$store.commit('cart/setPendingRequiredRego', regoObj);
          this.$router.push({
            name: 'finder',
            params: { membershipRequiredProducts: product.membershipProductsRequired },
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancelled',
          });
        });
        return;
      }

      if (fullSlot) {
        this.$notify({
          title: 'Full',
          message: 'This product is full.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      if (product.type === 'indv-to-team') {
        if (this.selectedTeam) {
        // You might want to show some modal or UI component here for the user to choose a team
        // Example:
          const filteredProducts = this.localRegistration.product.filter((p) => p._id === product._id);
          const regoObj = this.generateRegoObject(filteredProducts, this.selectedTeam);
          const registrations = this.$store.getters['cart/registrations'];

          if (regoObj.registrationType === 'event') {
            const {
              _id: entityId, productType, memberType, tags, ageFrom, ageTo
            } = regoObj;

            const foundRego = _.find(registrations, (r) => r.entityId === entityId
                                && r.memberId === this.memberId
                                && r.productType === productType
                                && r.ageFrom === ageFrom
                                && r.ageTo === ageTo
                                && r.memberType === memberType
                                && _.isEqual(r.tags, tags));
            if (foundRego && productType !== 'indv-to-team') {
              this.$store.commit('loading', false);
              this.$message.error('Registration for this member has already been added to cart.');
              return;
            }

            if (foundRego && productType === 'indv-to-team') {
              const currentTeamId = regoObj.selectedTeam;
              const foundTeam = _.find(registrations, (t) => t.team && t.team._id === currentTeamId);
              if (foundTeam) {
                this.$store.commit('loading', false);
                this.$message.error('Registration for this member has already been added to cart.');
                return;
              }
            }

            if (regoObj.productType === 'indv') {
              this.$store.commit('loading', false);
              const pathName = this.hasCustomEntity ? 'custom-event-register-individual' : 'event-register-individual';
              this.$router.push({
                name: pathName,
                params: { criteria: this.criteria, memberId: this.memberId, selectedEvent: regoObj },
              });
            } else if (regoObj.productType === 'indv-to-team') {
              if (regoObj.teams) {
                const team = regoObj.teams.find((item) => item._id === regoObj.selectedTeam);
                _.assign(regoObj, { team });
                delete regoObj.teams;
                delete regoObj.selectedTeam;
              }
              this.$store.commit('loading', false);
              const pathName = this.hasCustomEntity ? 'custom-event-register-individual-to-team' : 'event-register-individual-to-team';
              this.$router.push({
                name: pathName,
                params: { criteria: this.criteria, memberId: this.memberId, selectedEvent: regoObj },
              });
            } else {
              this.$store.commit('loading', false);
              this.$message.error('Registration for this product type is not available yet.');
            }
          }
        } else {
          this.$notify({
            title: 'No Teams Available',
            message: 'There are no teams available for this product.',
            type: 'warning',
            duration: 5000,
          });
        }
      }
    },
    generateRegoObject(filteredProducts, teamId, OrgId, team, customRego, entity) {
      const {
        acceptActiveKids, description, endDate, entityId, entityType, isRegoOpen, meta, registrationType, name, discounts,
        multipleRegoDiscounts, orgtree, regoEndDate, regoStartDate, saleableItems, additionalQs, startDate, teams, _id, isClubMembership, isRenewable
      } = customRego || this.localRegistration;
      const filteredAdditionalQs = additionalQs.filter((q) => {
        if (filteredProducts[0].type === 'team' || filteredProducts[0].type === 'entity') {
          return _.includes(q.productTypes, filteredProducts[0].type) && q.isActive;
        }
        return _.includes(q.productTypes, filteredProducts[0].type) && q.isActive && _.includes(q.memberTypes, filteredProducts[0].memberType);
      });
      const filteredSaleableItems = saleableItems.filter((si) => {
        if (filteredProducts[0].type === 'team' || filteredProducts[0].type === 'entity') {
          return _.includes(si.productTypes, filteredProducts[0].type) && si.isActive;
        }
        return _.includes(si.productTypes, filteredProducts[0].type) && si.isActive && _.includes(si.memberTypes, filteredProducts[0].memberType);
      });
      const regoObj = {
        acceptActiveKids,
        name,
        registrationType,
        isClubMembership,
        isRenewable,
        description,
        endDate,
        entityId,
        entityType,
        isRegoOpen,
        meta,
        discounts,
        multipleRegoDiscounts,
        orgtree,
        products: filteredProducts,
        regoEndDate,
        regoStartDate,
        // filter saleable Items with matching product type and memberType and isActive
        saleableItems: filteredSaleableItems,
        additionalQs: filteredAdditionalQs,
        startDate,
        teams,
        _id,
        productType: filteredProducts[0].type,
        tags: filteredProducts[0].tags,
      };
      if (filteredProducts[0].type !== 'team' || filteredProducts[0].type !== 'entity') {
        _.assign(regoObj, { memberType: filteredProducts[0].memberType });
      }
      if (teamId) {
        _.assign(regoObj, { selectedTeam: teamId });
      }
      if (OrgId) {
        _.assign(regoObj, { selectedEntity: OrgId });
      }
      if (team && team._id) {
        _.assign(regoObj, { team });
      }
      if (entity && entity._id) {
        _.assign(regoObj, { entity });
      }
      this.$store.commit('cart/setPendingRegistration', this.localRegistration._id);
      return regoObj;
    },
    isEligible(product) {
      if (this.selectedMember) {
        // find the registration product based on the productid
        // const foundProduct = this.localRegistration.product.find((p) => p._id === productId);
        if (product) {
          // check gender of the product  and calculate the age of the member and conpare with the age range of the product
          const {
            gender, ageFrom, ageTo,
          } = product;
          const { dob, gender: memberGender } = this.selectedMember.profile;
          const age = this.calculateAge(dob);
          if (ageFrom <= age && ageTo >= age && (memberGender === gender || gender === 'All' || !gender || (gender === 'Other' && (memberGender !== 'Male' && memberGender !== 'Female')))) {
            return true;
          }
          return false;
        }
      }
      return true;
    },
    calculateAge(dob) {
      const endOfYear = this.$store.getters['national/endOfYear'];
      const age = calculateMemberAge(dob, endOfYear);
      return age;
    },
    closeDialog() {
      this.showInviteModal = false;
      this.dialogState = 'initial';
    },
    async showProducts() {
      const activeMember = this.$store.getters['user/activeMember'];
      if (activeMember && activeMember._id) {
        this.memberId = activeMember._id;
      }
      this.dialogState = 'showProducts';
      const teamRego = _.get(this.$route.params, 'confirmationData', '');
      const criteria = teamRego.eventId;
      this.selectedTeam = teamRego.team._id;
      const filters = {
        ageFrom: 1,
        ageTo: 100,
        eventDateRange: [],
        memberId: this.memberId,
        regoOpen: 'open',
      };
      this.selectedMember = this.memberList.find((m) => m._id === this.memberId);
      const response = await this.$http.get(`/assemble/api/v1/portal/registrations/members/${this.memberId}`);
      this.memberMembership = response.data.data;
      const resSearch = await this.$http.post('/assemble/api/v1/portal/registrations/new-search/20/1', {
        criteria: _.trim(criteria),
        filters,
      });
      [this.localRegistration] = resSearch.data.data.result;
      this.teamProducts = this.localRegistration.product.filter((product) => product.type === 'indv-to-team');
      if (!this.selectedTeam) {
        const findTeam = this.localRegistration.teams.find((team) => team.name === teamRego.team.name);
        this.selectedTeam = findTeam._id;
      }
      console.log('teamRego', this.teamProducts);
      // const productsRes = await this.$http.get('assemble/api/v1/portal/products');
    },
    isMembershipRequired(product) {
      if (product.type === 'team') return false;
      if (product.isMembershipRequired) {
        const foundMemberships = product.membershipProductsRequired
          .reduce((updatedMembership, pr) => {
            let foundRequiredMS = [];
            if (pr.products.tags && pr.products.tags.length) {
              const tagArray = pr.products.tags;
              foundRequiredMS = this.memberMembership
                .filter((m) => (_.get(m, 'regoEntity.products.tags', []).length === tagArray.length)
                    && _.get(m, 'regoEntity.products.tags', []).length
                    && m.regoEntity.products.tags.every((tag, index) => tag._id === tagArray[index]._id)
                    && pr._id === m.entityId && pr.products.type === m.productType && pr.products.memberType === m.memberType && m.expired !== true);
            } else {
              foundRequiredMS = this.memberMembership
                .filter((m) => product.membershipProductsRequired.some((p) => p._id === m.entityId
                    && p.products.type === m.productType
                    && p.products.memberType === m.memberType
                    && m.expired !== true));
            }
            return updatedMembership.concat(foundRequiredMS);
          }, []);

        if (!foundMemberships.length) {
          return true;
        }
      }
      return false;
    },
    scrollToContent() {
      this.$refs.content.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    },
    go(path) {
      this.$router.push(path);
    },
    goToFinder() {
      this.$store.commit('cart/clearConfirmation');
      const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
      // push with query params
      this.$router.push({
        name: pathName,
        params: { pendingRegistration: this.pendingRegistration },
      });
    },
    goToPayment() {
      this.$emit('goToPayment');
      this.$store.commit('cart/clearConfirmations');
      this.$store.commit('cart/clearTeamRegistrations');
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    transformFamilyToIndvRegistration() {
      const formattedRegistrations = [];
      _.forEach((this.payment.registrations), (r) => {
        if (r.productType === 'family') {
          _.forEach((r.familyRegistrations), (rego, index) => {
            // eslint-disable-next-line no-param-reassign
            rego.product.price = index === 0 ? r.product.price : 0;
            // eslint-disable-next-line no-param-reassign
            rego.payToday = index === 0 ? r.payToday : 0;
            if (index !== 0 && _.get(rego, 'product.customFees')) {
              // eslint-disable-next-line no-param-reassign
              delete rego.product.customFees;
            }
            const obj = {
              ...r,
              ...rego,
              memberId: rego.memberId,
              memberType: rego.memberType,
              productId: rego.productId,
              profile: rego.profile,
            };
            formattedRegistrations.push(obj);
          });
        } else if (r.productType === 'indv' || r.productType === 'indv-to-team') {
          formattedRegistrations.push(r);
        }
      });
      return formattedRegistrations;
    },
    executeRegistations(token) {
      // Use getCurrentIndvCartTotal() to get the current reactive value instead of stale prop
      const currentIndvTotal = this.getCurrentIndvCartTotal ? this.getCurrentIndvCartTotal() : this.indvCartTotal;
      // Use props passed from Payment.vue which include fixed tech fee
      const paymentTotal = this.indvPayTodayTotal || this.payTodayTotal;
      const payToday = currentIndvTotal || this.cartTotal;
      const paymentInstallment = this.indvPayTodayTotal || this.payTodayTotal;

      console.log('this.transformFamilyToIndvRegistration()', this.transformFamilyToIndvRegistration());
      const checkOutDiscounts = _.filter(this.currentDiscounts, (discount) => discount.type === 'checkoutTotal');
      const url = this.payment.registrations[0].isBulk ? '/assemble/api/v1/portal/registrations/bulk-register' : '/assemble/api/v1/portal/registrations/register';
      this.$http.post(url, {
        registrations: this.transformFamilyToIndvRegistration(),
        cardToken: token,
        paymentTotal,
        payToday,
        paymentInstallment,
        regoDiscounts: this.regoDiscounts,
        checkOutDiscounts,
      }).then(() => {
        // this.$message.success('Successfully registered.');
        console.log('this.transformFamilyToIndvRegistration()', this.transformFamilyToIndvRegistration());
        // const confirmation = _.cloneDeep(this.registrationsConfirmation);
        // console.log('confirmation', confirmation);
        this.$store.commit('cart/setConfirmations', this.registrationsConfirmation);
        this.$store.commit('cart/clearCart');
        this.isRegoBlurred = false;
        this.isRegoSuccess = true;
        if (this.selectedBulkMembers.length > 0) {
          this.bulkMembers = _.cloneDeep(this.selectedBulkMembers);
          this.$store.commit('cart/clearSelectedBulkMembers', this.selectedBulkMembers);
        }
        // this.$router.push('/success');
        // update step
        this.active++;
        console.log('this.isTeamRego', this.isTeamRego);
        if (this.isTeamRego) {
          // this.showInviteModal = true;
        }
        this.$store.commit('loading', false);
      }).catch((err) => {
        const serverError = _.get(err, 'response.data.message');
        this.isRegoBlurred = false;
        this.isRegoSuccess = false;
        this.active++;
        this.regoErrorMessages = _.get(err, 'response.data.message', 'There has been an error');
        console.log('err at register', err);
        if (err.response.data.data) {
          const { product, memberId } = err.response.data.data;
          const regoIndex = this.registrationsConfirmation.findIndex((r) => {
            if (r.productType === 'indv' || r.productType === 'indv-to-team') {
              return r.product._id === product._id && r.memberId === memberId;
            }
            if (r.productType === 'family') {
              console.log('r.familyRegistrations', r.familyRegistrations);
              return r.product._id === product._id;
            }
            return false;
          });
          console.log('regoIndex', regoIndex);
          if (regoIndex > -1) {
            this.registrationsConfirmation[regoIndex].errorMessages = err.response.data.message;
          }
          this.$store.commit('cart/setConfirmations', this.registrationsConfirmation);
        }
        this.$message.error({ message: serverError || 'There has been an error', duration: 0 });
      });
    },
    checkCustomFees() {
      _.forEach(this.payment.registrations, (rego) => {
        if (_.get(rego, 'product.customFees.qty') >= 0) {
          const newValue = _.get(rego, 'product.customFees.value') * _.get(rego, 'product.customFees.qty');
          // eslint-disable-next-line no-param-reassign
          rego.product.customFees.value = newValue;
        }
      });
    },
    async purchase(token) {
      // this.$store.commit('cart/clearConfirmation');
      this.$http.post('assemble/api/v1/portal/saleable-items/purchase', {
        saleableItems: this.payment.directSaleableItems,
        cardToken: token,
        paymentTotal: this.totalSaleableItemsWithFee,
      }).then(() => {
        // this.$message.success('Successfully registered.');
        // this.$store.commit('cart/successful');
        this.isSIBlurred = false;
        this.isSISuccess = true;
        this.active++;
        this.$store.commit('cart/clear');
        // this.$router.push('/success');
        // update step

        // this.$store.commit('loading', false);
      }).catch((err) => {
        const serverError = _.get(err, 'response.data.message');
        // this.$store.commit('loading', false);
        this.isSIBlurred = false;
        this.isSISuccess = false;
        this.active++;
        this.siErrorMessages = _.get(err, 'response.data.errors', 'There has been an error');
        this.$message.error(serverError || 'There has been an error');
      });
    },
    async register(token) {
      this.checkCustomFees();
      if (this.payment.registrations.length >= 1) {
        // eslint-disable-next-line no-restricted-syntax
        for (const [index, event] of this.payment.registrations.entries()) {
          console.log('test', event);
          // if (_.get(event, 'product.customFees.required') && _.get(event, 'product.customFees.isFixedValue') === false && _.get(event, 'product.customFees.value') === 0) {
          //   try {
          //     // eslint-disable-next-line no-await-in-loop
          //     await this.$confirm(`Would you like to contribute for ${_.get(event, 'product.name', '') !== '' ? event.product.name : event.entityName}`, `${event.product.customFees.label}`, {
          //       confirmButtonText: 'Yes',
          //       cancelButtonText: 'No',
          //       type: 'warning'
          //     });

          //     // if yes pop up another dialog to ask how much they want to donate
          //     // eslint-disable-next-line no-await-in-loop
          //     const donationResponse = await this.$prompt('Please enter the amount you would like to contribute', `${event.product.customFees.label}`, {
          //       confirmButtonText: 'Confirm',
          //       cancelButtonText: 'Cancel',
          //       inputPattern: /\d+/,
          //       inputErrorMessage: 'Please enter a valid number'
          //     });

          //     // eslint-disable-next-line no-param-reassign
          //     event.product.customFees.value = parseInt(donationResponse.value) * 100;
          //     // update the payment regisration
          //     this.payment.registrations[index] = event;
          //     // update the summary
          //     this.summary[index].products.push({
          //       name: event.product.customFees.label,
          //       description: '',
          //       qty: 1,
          //       total: event.product.customFees.value,
          //       price: event.product.customFees.value,
          //       isCustomFees: true
          //     });
          //     // update the this.total
          //     this.total += event.product.customFees.value;
          //   } catch (err) {
          //     console.log(err);
          //   }
          // }

          // Only execute the post request after the last donation confirmation
          if (index === this.payment.registrations.length - 1) {
            this.executeRegistations(token);
          }
        }
      } else {
        // this.executeRegistations(token);
      }
    },
  },

  watch: {
    // payment: {
    //   immediate: true,
    //   deep: true,
    //   handler(newVal) {
    //     if (newVal && newVal.registrations && newVal.registrations.length >= 1) {
    //       this.register(this.token1);
    //     } else if (newVal && newVal.directSaleableItems && newVal.directSaleableItems.length >= 1) {
    //       this.saleableItemConfirmation = newVal.directSaleableItems;
    //       this.purchase(this.token2);
    //     }
    //   }
    // }
  }
};
</script>

  <style lang="scss" scoped>
  ::v-deep .el-steps--simple{
    background: var(--highlight-color);
    color: var(--text-color-primary)
  }
  .container {
    margin: 1rem auto;
  }
  .products-dialog {
  h2 {
    text-align: center;
    margin-bottom: 20px;
  }
}

::v-deep .el-card__body {
  padding: 0.5rem !important;
}

.product-container-main-mobile{

    &::v-deep.el-card__body {
      padding: 0.5rem !important;
    }

      .product-description{
        display: grid;
        // justify-content: space-between;
        margin: 11px 0 0 0;
        padding: 0 1rem;
        gap: 0.5rem;

        .dark-color{
          background: #c4c4c4;
        }
        .member-type{
          flex-basis: 50%;
        }
        .gender{
          flex-basis: 30%;
        }
        .age{
          flex-basis: 20%;
        }
        .product-displayName{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          opacity: 0.6;
          font-style: normal;
          font-weight: 500;
          font-size: 1rem;
          line-height: 1.8rem;
          // limit line to 5
          .max-lines {
            /* Set a height for the container */
            max-height: 9rem; /* 5 lines x 0.75rem line height */
            overflow: hidden;
            font-style: normal;
            font-weight: 700;
            font-size: 1.2rem;
            line-height: 1.8rem;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
          }
          .max-lines p {
            margin: 0; /* remove any margin that may be applied to the p tag by default */
            line-height: 1.8rem; /* set the desired line height */
          }

        }

        .product-tags{
          align-items: center;
          display: flex;
          span{
            font-family: $fontBold !important;
            font-weight: 700;
            font-size: 15px;
            line-height: 25px;
            letter-spacing: -0.5px;
            color: #303133;
            opacity: 0.6;
          }
          overflow: hidden;
          word-break: break-word !important;
        }
        .product-price{
          font-style: normal;
          font-weight: 400;
          font-size: 1rem;
          line-height: 1.8rem;
          display: flex;
          align-items: center;
          letter-spacing: -0.5px;
          color: #303133;
        }
      }
      .grid-style{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
      }
      .product-register{
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        // justify-content: flex-end;
        // flex-direction: column;
        .secondary-type-button{
          background: var(--secondary-color);
          color: #000;
          &:hover{
            // hover color to higher contrast
            background: var(--secondary-color);
            opacity: 0.8;
            color: #000;
          }
        }
        .primary-type-button{
          margin: 0;
          // display: flex;
          // border-radius: 50px;
          // text-align: center;
          // align-items: center;
          // justify-content: center;
          // margin-bottom: 10px;
        }
      }
    }
    // .container {
    //   @media screen and (max-width: 768px) {
    //     // background: white;
    //   }

    //   .button {
    //     max-width: 15rem;
    //     margin: 0 auto;
    //   }

    //   .content {
    //     max-width: 1280px;
    //     margin: 0 auto;
    //     margin-top: 0rem;
    //     display: grid;
    //     // gap: 3vmax;
    //     padding: 0 3vmax;
    //     @media screen and (max-width: 768px) {
    //       padding: 0;
    //       .el-breadcrumb {
    //         margin-left: 3vmax;
    //       }
    //     }
    //     .section-header {
    //       margin-left: 0.5rem;
    //       margin-bottom: 2rem;
    //       font-size: clamp(1.5rem, 1.95vmax, 2.25rem);
    //       line-height: clamp(2rem, 2.35vmax, 2.5rem);
    //     }
    //   }
    // }
    .progress-indicator {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  flex-wrap: wrap;
}

.progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-width: 80px;
  margin-bottom: 20px;
}

.step-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  margin-bottom: 10px;
}

.step-label {
  font-size: 14px;
  text-align: center;
}

.progress-line {
  flex-grow: 1;
  height: 2px;
  background-color: #e0e0e0;
  margin: 0 10px;
}

.progress-step.completed .step-icon {
  background-color: #67c23a;
}

.progress-step.completed + .progress-line {
  background-color: #67c23a;
}

@media (max-width: 768px) {
  .progress-indicator {
    flex-direction: column;
    align-items: flex-start;
  }

  .progress-step {
    flex-direction: row;
    width: 100%;
    margin-bottom: 15px;
  }

  .step-icon {
    margin-right: 15px;
    margin-bottom: 0;
  }

  .progress-line {
    width: 2px;
    height: 20px;
    margin: 0 0 0 19px; // Half of step-icon width minus half of line width
  }
}
  </style>
